import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';

import TableauGraphe from './TableauGraphe/TableauGraphe';
import ProfilGraphe from './ProfilGraphe/ProfilGraphe';
import FormulaireGraphe from './ProfilGraphe/FormulaireGraphe/FormulaireGraphe';
import Bouton from '../UI/Bouton/Bouton';
import ConteneurInformation from '../ConteneurInformation/ConteneurInformation';

import * as actions from '../../services/actions';
import * as indexConteneurInfo from '../../ressources/glossaires/glossaire_conteneur_info';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import { checkMot } from '../../ressources/functionJS/checkMot';
import S from './Graphe.module.scss';

const Graphe = () => {
  // Separate state with useState hooks
  const [selectedParams, setSelectedParams] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [containerIndex, setContainerIndex] = useState(null);
  const [showFullInfo, setShowFullInfo] = useState(false);

  const dispatch = useDispatch();

  // Event handlers
  const handleLineSelection = (info) => {
    setSelectedParams(info);
    setContainerIndex(indexConteneurInfo.profil);
    setShowInfo(true);
  };

  const toggleInfoCreator = () => {
    setShowInfo((prev) => {
      if (prev) {
        setShowFullInfo(false);
        return false;
      }
      return true;
    });
  };

  const toggleFullInfo = () => {
    setShowFullInfo((prev) => !prev);
  };

  const handleCancel = () => {
    setShowInfo(false);
    setContainerIndex(null);
  };

  const createGraph = () => {
    setShowInfo(true);
    setContainerIndex(indexConteneurInfo.ajouterForm);
  };

  // Redux action handlers
  const handleAddAlert = (alertType, title, body) => {
    dispatch(actions.ajouterAlerte(alertType, title, body));
  };

  const handleCreateGraph = (graphForm) => {
    dispatch(actions.reqCreerGraphe(graphForm));
  };

  const handleDeleteGraph = (graphId) => {
    dispatch(actions.reqSupprimerGraphe(graphId));
  };

  // Style management
  const leftContainerStyle = [S.ConteneurCentralGauche];
  const rightContainerStyle = [S.ConteneurCentralDroite];
  const togglerClasses = [S.CommutateurInfo];

  if (showInfo && showFullInfo) {
    rightContainerStyle.push(S.ConteneurCentralDroiteFull);
    leftContainerStyle.push(S.ConteneurCentraGaucheVoid);
  } else if (showInfo && !showFullInfo) {
    rightContainerStyle.push(S.ConteneurCentralDroiteOuvert);
  } else {
    rightContainerStyle.push(S.ConteneurCentralDroiteFermer);
    leftContainerStyle.push(S.ConteneurCentraGaucheFermer);
  }

  return (
    <div className={S.ConteneurGraphe}>
      <div className={leftContainerStyle.join(' ')}>
        <TableauGraphe
          projetSelectione={handleLineSelection}
          creer={createGraph}
        />
        <div className={S.titleModule}>{checkMot('graphes')}</div>
      </div>
      <div className={rightContainerStyle.join(' ')}>
        <Bouton
          ajoutClass={[togglerClasses, S.expandTO].join(' ')}
          cliquer={toggleInfoCreator}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromLeft size={15} />
        </Bouton>
        <Bouton
          ajoutClass={S.expand}
          cliquer={toggleFullInfo}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromRight size={15} />
        </Bouton>
        <ConteneurInformation
          selectionInfo={containerIndex}
          ajouterForm={
            <FormulaireGraphe
              ajouterAlerte={handleAddAlert}
              annuler={handleCancel}
            />
          }
          profil={
            <ProfilGraphe
              infoGraphe={selectedParams}
              reqModifier={dispatch}
              reqCreerGraphe={handleCreateGraph}
              reqSupprimer={handleDeleteGraph}
            />
          }
        />
      </div>
    </div>
  );
};

export default Graphe;
